import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Check } from "lucide-react";
import { api, formatPrice } from "@/lib/api";

export default function OrderSuccess() {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  useEffect(() => { api.get(`/orders/${id}`).then((r) => setOrder(r.data)); }, [id]);

  return (
    <div className="ja-container py-16 md:py-24 text-center" data-testid="order-success">
      <div className="w-16 h-16 mx-auto rounded-full flex items-center justify-center" style={{ background: "var(--ja-champagne)" }}>
        <Check size={28} />
      </div>
      <p className="ja-overline mt-8">Thank You</p>
      <h1 className="ja-serif text-5xl md:text-6xl mt-3 tracking-tight">Your order is placed.</h1>
      {order && (
        <div className="max-w-xl mx-auto mt-10 border p-8 text-left" style={{ borderColor: "var(--ja-border)", background: "var(--ja-ivory)" }}>
          <div className="flex justify-between text-sm mb-3"><span>Order Number</span><span data-testid="order-number">{order.order_number}</span></div>
          <div className="flex justify-between text-sm mb-3"><span>Status</span><span>{order.status}</span></div>
          <div className="flex justify-between text-sm mb-3"><span>Total</span><span>{formatPrice(order.total, order.currency)}</span></div>
          <div className="flex justify-between text-sm"><span>Payment</span><span>{order.payment_method} · {order.payment_status}</span></div>
        </div>
      )}
      <div className="mt-10 flex gap-4 justify-center">
        <Link to="/account" className="ja-btn-outline">View Orders</Link>
        <Link to="/shop" className="ja-btn">Continue Shopping</Link>
      </div>
    </div>
  );
}
